import { getRetailAd } from './getRetailAd';

export const retailAdService = {
  getRetailAd,
};
